import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import { NotificationResponse } from '../../components/admin-dashboard-component/header/header.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private httpClient = inject(HttpClient);
  private API = environment.notificationsUrl;
  private authService = inject(AuthService);

  getAllNotifications(params?: { pageOffset: number; pageSize: number }) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.get<NotificationResponse>(`${this.API}/notifications/web`, { params, headers });
  }

  markNotificationAsRead(messageId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.put(
      `${this.API}/notifications/web/${messageId}/read`,
      {},
      {
        headers,
      },
    );
  }
}
